import React, { useState } from 'react';
import { Button } from 'antd';
import { PhotoGrid } from '../../PhotoGallery/PhotoGrid';
import { PhotoGalleryDrawer } from '../../PhotoGallery/PhotoGalleryDrawer';
import type { PhotoMetadata } from '../../PhotoGallery/PhotoOverlayInfo';
import ProfileSection from './ProfileSection';
import '../Profile.css';

export interface ShowPhotosSectionProps {
  photos: string[];
  photoMetadata?: PhotoMetadata[];
  maxPhotos?: number;
  subtitle?: string;
}

export const ShowPhotosSection: React.FC<ShowPhotosSectionProps> = ({
  photos,
  photoMetadata,
  maxPhotos = 9,
  subtitle,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (photos.length === 0) return null;

  return (
    <ProfileSection title="Show Photos" subtitle={subtitle} rightAction={<Button size="small" onClick={() => setDrawerOpen(true)}>View All</Button>}>
      <PhotoGrid
        photos={photos}
        maxPhotos={maxPhotos}
        photoMetadata={photoMetadata}
        showOverlayUserInfo
        showOverlayEventInfo
        onViewAll={() => setDrawerOpen(true)}
      />
      <PhotoGalleryDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        photos={photos}
        title="Show Photos"
        showTabs
        upcomingPhotos={photos}
        pastPhotos={photos}
        fullscreen
        drawerProps={{ zIndex: 1100 }}
        photoMetadata={photoMetadata}
        showOverlayUserInfo
        showOverlayEventInfo
      />
    </ProfileSection>
  );
};

export default ShowPhotosSection;
